<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/59/title-bg.png" alt="" />
            <div class="technological-process">
                <div class="rhtj mar-t2">
                    <img class="top" src="./../assets/imgs/59/title-1.png" alt="" />
                    <div class="content">
                        产业菁英人才所在企业须符合彭州市主导产业发展方向（或满足下列条件之一的企业：引进当年有研发投入、自主知识产权、承担成都市级及以上科技项目）。
                    </div>
                </div>
                <div class="sbcl">
                    <img class="top" src="./../assets/imgs/28/title-2.png" alt="" />
                    <div class="content">
                        <div class="des">
                            <div class="item">
                                <div class="dot">1</div>
                                彭州市支持高层次人才创新创业申报书；
                            </div>
                            <div class="item">
                                <div class="dot">2</div>
                                企业统一社会信用代码注册登记证（照）或营业执照复印件，个人身份证复印件；
                            </div>
                            <div class="item">
                                <div class="dot">3</div>
                                与彭州市企业签订的劳动合同复印件；
                            </div>
                            <div class="item">
                                <div class="dot">4</div>
                                申报书填报时间之前2年以内的申报人缴纳个税记录及社保缴费记录；
                            </div>
                            <div class="item">
                                <div class="dot">5</div>
                                副高级职称及以上的专业技术人才的职称证明材料，或博士研究生、全日制硕士研究生的学历、学位证明材料，或高级技师的技能证明材料；
                            </div>
                            <div class="item">
                                <div class="dot">6</div>
                                主要成果（包括代表性论文或著作、专利证书、产品证书等）证明材料或复印件、获奖证书复印件；
                            </div>
                            <div class="item">
                                <div class="dot">7</div>
                                如企业非彭州市主导产业发展方向，则需提供税款所属期为引进当年的研发费用加计扣除优惠明细表（A107012表），或取得自主知识产权的相关佐证材料（或授权证书），或承担成都市级及以上科技项目的相关佐证材料。
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/59/title-3.png" alt="" />
                    <div class="content">
                        <div class="des">
                            1.对正高级职称专业技术人才，给予25万元资助，分5年发放；经年度考核后，申领资助最高5万元/年。
                        </div>
                        <div class="des">
                            2.对博士研究生、副高级职称专业技术人才、高级技师，给予18万元资助，分5年发放；经年度考核后，申领资助最高3.6万元/年。
                        </div>
                        <div class="des">
                            3.对全日制硕士研究生，给予10万元资助，分5年发放；经年度考核后，申领资助最高2万元/年。
                        </div>
                    </div>
                </div>
                <div class="gmlc">
                    <img class="top" src="./../assets/imgs/28/title-4.png" alt="" />
                    <div class="content">
                        <div class="des mar-t3">
                            <div class="line-item">
                                <div class="dot">1</div>
                                <div class="line"></div>
                                发布通知
                            </div>
                            <div class="line-item">
                                <div class="dot">2</div>
                                <div class="line"></div>
                                组织申报
                            </div>
                            <div class="line-item">
                                <div class="dot">3</div>
                                <div class="line"></div>
                                初审汇总
                            </div>
                            <div class="line-item">
                                <div class="dot">4</div>
                                <div class="line"></div>
                                资质核查
                            </div>
                            <div class="line-item">
                                <div class="dot">5</div>
                                <div class="line"></div>
                                审定公示
                            </div>
                            <div class="line-item">
                                <div class="dot">6</div>
                                资金发放
                            </div>
                        </div>
                    </div>
                </div>
                <div class="contact" style="margin-top: 0.8rem">
                    <img class="top" src="./../assets/imgs/25/title-5.png" alt="" />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-83890656">028-83890656</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            市经科信局
                        </div>
                    </div>
                </div>
                <div class="codes">
                    <img class="code" src="../assets/imgs/59/code.png" />
                    <img class="text" src="../assets/imgs/59/text.png" />
                </div>
            </div>
        </section>
        <!-- <call phone="028-83221725"></call> -->
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 5.6rem;
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .rhtj {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                font-size: 0.26rem;
                color: #333333;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                text-align: left;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
            }
        }

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.5rem;
                    position: relative;
                }
            }
        }

        .sbcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    // margin-top: 0.5rem;
                    position: relative;

                    .title {
                        font-size: 0.3rem;
                        font-weight: bold;
                        color: #333333;
                    }

                    .item {
                        margin-top: 0.22rem;
                        box-sizing: border-box;
                        position: relative;
                        padding-left: 0.42rem;
                        display: flex;

                        .dot {
                            width: 0.39rem;
                            height: 0.39rem;
                            background-color: #739bfe;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 0.28rem;
                            color: #fff;
                            border-radius: 50%;
                            position: absolute;
                            left: -0.1rem;
                            top: 0;
                            z-index: 9999;
                        }
                    }
                }
            }
        }

        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.55rem auto;
                padding: 0 0.33rem 0.35rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;

                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;
                        padding-left: 0.5rem;
                        box-sizing: border-box;
                        margin-bottom: 0.35rem;

                        .dot {
                            width: 0.39rem;
                            height: 0.39rem;
                            background-color: #739bfe;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 0.28rem;
                            color: #fff;
                            border-radius: 50%;
                            position: absolute;
                            left: -0.1rem;
                            top: 0;
                            z-index: 9999;
                        }

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 135%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.1rem;
                            z-index: 0;
                            top: 0.2rem;
                        }
                    }
                }
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .code {
                width: 1.94rem;
                height: 1.94rem;
            }

            .text {
                height: 1.59rem;
            }
        }
    }
}
</style>
